export const enum SuggestType {
  FINAL = 'final',
  IN_PROGRESS = 'in-progress',
}
